import capitalize from 'lodash.capitalize';
import { UserRoleEnum } from '@api/enum';
import { UserThemeEnum } from '@api/enum';
import { UserStatusEnum } from '@api/enum';
// import { timezoneList } from "modules/shared/helpers/shared.constants";

export const CountryDialCodeList = [
    {
        countryName: 'Afghanistan',
        countryCode: 'af',
        dialCode: '+93',
        areaCodes: [],
        flag: '/flags/af.svg',
    },
    {
        countryName: 'Albania',
        countryCode: 'al',
        dialCode: '+355',
        areaCodes: [],
        flag: '/flags/al.svg',
    },
    {
        countryName: 'Algeria',
        countryCode: 'dz',
        dialCode: '+213',
        areaCodes: [],
        flag: '/flags/dz.svg',
    },
    {
        countryName: 'American Samoa',
        countryCode: 'as',
        dialCode: '+1',
        areaCodes: ['684'],
        flag: '/flags/as.svg',
    },
    {
        countryName: 'Andorra',
        countryCode: 'ad',
        dialCode: '+376',
        areaCodes: [],
        flag: '/flags/ad.svg',
    },
    {
        countryName: 'Angola',
        countryCode: 'ao',
        dialCode: '+244',
        areaCodes: [],
        flag: '/flags/ao.svg',
    },
    {
        countryName: 'Anguilla',
        countryCode: 'ai',
        dialCode: '+1',
        areaCodes: ['264'],
        flag: '/flags/ai.svg',
    },
    {
        countryName: 'Antigua and Barbuda',
        countryCode: 'ag',
        dialCode: '+1',
        areaCodes: ['268'],
        flag: '/flags/ag.svg',
    },
    {
        countryName: 'Argentina',
        countryCode: 'ar',
        dialCode: '+54',
        areaCodes: [],
        flag: '/flags/ar.svg',
    },
    {
        countryName: 'Armenia',
        countryCode: 'am',
        dialCode: '+374',
        areaCodes: [],
        flag: '/flags/am.svg',
    },
    {
        countryName: 'Aruba',
        countryCode: 'aw',
        dialCode: '+297',
        areaCodes: [],
        flag: '/flags/aw.svg',
    },
    {
        countryName: 'Ascension Island',
        countryCode: 'ac',
        dialCode: '+247',
        areaCodes: [],
        flag: '/flags/ac.svg',
    },
    {
        countryName: 'Australia',
        countryCode: 'au',
        dialCode: '+61',
        areaCodes: [],
        flag: '/flags/au.svg',
    },
    {
        countryName: 'Austria',
        countryCode: 'at',
        dialCode: '+43',
        areaCodes: [],
        flag: '/flags/at.svg',
    },
    {
        countryName: 'Azerbaijan',
        countryCode: 'az',
        dialCode: '+994',
        areaCodes: [],
        flag: '/flags/az.svg',
    },
    {
        countryName: 'Bahamas',
        countryCode: 'bs',
        dialCode: '+1',
        areaCodes: ['242'],
        flag: '/flags/bs.svg',
    },
    {
        countryName: 'Bahrain',
        countryCode: 'bh',
        dialCode: '+973',
        areaCodes: [],
        flag: '/flags/bh.svg',
    },
    {
        countryName: 'Bangladesh',
        countryCode: 'bd',
        dialCode: '+880',
        areaCodes: [],
        flag: '/flags/bd.svg',
    },
    {
        countryName: 'Barbados',
        countryCode: 'bb',
        dialCode: '+1',
        areaCodes: ['246'],
        flag: '/flags/bb.svg',
    },
    {
        countryName: 'Belarus',
        countryCode: 'by',
        dialCode: '+375',
        areaCodes: [],
        flag: '/flags/by.svg',
    },
    {
        countryName: 'Belgium',
        countryCode: 'be',
        dialCode: '+32',
        areaCodes: [],
        flag: '/flags/be.svg',
    },
    {
        countryName: 'Belize',
        countryCode: 'bz',
        dialCode: '+501',
        areaCodes: [],
        flag: '/flags/bz.svg',
    },
    {
        countryName: 'Benin',
        countryCode: 'bj',
        dialCode: '+229',
        areaCodes: [],
        flag: '/flags/bj.svg',
    },
    {
        countryName: 'Bermuda',
        countryCode: 'bm',
        dialCode: '+1',
        areaCodes: ['441'],
        flag: '/flags/bm.svg',
    },
    {
        countryName: 'Bhutan',
        countryCode: 'bt',
        dialCode: '+975',
        areaCodes: [],
        flag: '/flags/bt.svg',
    },
    {
        countryName: 'Bolivia',
        countryCode: 'bo',
        dialCode: '+591',
        areaCodes: [],
        flag: '/flags/bo.svg',
    },
    {
        countryName: 'Bosnia and Herzegovina ',
        countryCode: 'ba',
        dialCode: '+387',
        areaCodes: [],
        flag: '/flags/ba.svg',
    },
    {
        countryName: 'Botswana',
        countryCode: 'bw',
        dialCode: '+267',
        areaCodes: [],
        flag: '/flags/bw.svg',
    },
    {
        countryName: 'Brazil ',
        countryCode: 'br',
        dialCode: '+55',
        areaCodes: [],
        flag: '/flags/br.svg',
    },
    {
        countryName: 'British Indian Ocean Territory',
        countryCode: 'io',
        dialCode: '+246',
        areaCodes: [],
        flag: '/flags/io.svg',
    },
    {
        countryName: 'British Virgin Islands',
        countryCode: 'vg',
        dialCode: '+1',
        areaCodes: ['284'],
        flag: '/flags/vg.svg',
    },
    {
        countryName: 'Brunei',
        countryCode: 'bn',
        dialCode: '+673',
        areaCodes: [],
        flag: '/flags/bn.svg',
    },
    {
        countryName: 'Bulgaria ',
        countryCode: 'bg',
        dialCode: '+359',
        areaCodes: [],
        flag: '/flags/bg.svg',
    },
    {
        countryName: 'Burkina Faso',
        countryCode: 'bf',
        dialCode: '+226',
        areaCodes: [],
        flag: '/flags/bf.svg',
    },
    {
        countryName: 'Burundi ',
        countryCode: 'bi',
        dialCode: '+257',
        areaCodes: [],
        flag: '/flags/bi.svg',
    },
    {
        countryName: 'Cambodia ',
        countryCode: 'kh',
        dialCode: '+855',
        areaCodes: [],
        flag: '/flags/kh.svg',
    },
    {
        countryName: 'Cameroon ',
        countryCode: 'cm',
        dialCode: '+237',
        areaCodes: [],
        flag: '/flags/cm.svg',
    },
    {
        countryName: 'Canada',
        countryCode: 'ca',
        dialCode: '+1',
        areaCodes: [
            '204',
            '226',
            '236',
            '249',
            '250',
            '263',
            '289',
            '306',
            '343',
            '354',
            '365',
            '367',
            '368',
            '382',
            '387',
            '403',
            '416',
            '418',
            '428',
            '431',
            '437',
            '438',
            '450',
            '584',
            '468',
            '474',
            '506',
            '514',
            '519',
            '548',
            '579',
            '581',
            '584',
            '587',
            '604',
            '613',
            '639',
            '647',
            '672',
            '683',
            '705',
            '709',
            '742',
            '753',
            '778',
            '780',
            '782',
            '807',
            '819',
            '825',
            '867',
            '873',
            '902',
            '905',
        ],
        flag: '/flags/ca.svg',
    },
    {
        countryName: 'Cape Verde ',
        countryCode: 'cv',
        dialCode: '+238',
        areaCodes: [],
        flag: '/flags/cv.svg',
    },
    {
        countryName: 'Caribbean Netherlands',
        countryCode: 'bq',
        dialCode: '+599',
        areaCodes: ['3', '4', '7'],
        flag: '/flags/bq.svg',
    },
    {
        countryName: 'Cayman Islands',
        countryCode: 'ky',
        dialCode: '+1',
        areaCodes: ['345'],
        flag: '/flags/ky.svg',
    },
    {
        countryName: 'Central African Republic ',
        countryCode: 'cf',
        dialCode: '+236',
        areaCodes: [],
        flag: '/flags/cf.svg',
    },
    {
        countryName: 'Chad ',
        countryCode: 'td',
        dialCode: '+235',
        areaCodes: [],
        flag: '/flags/td.svg',
    },
    {
        countryName: 'Chile',
        countryCode: 'cl',
        dialCode: '+56',
        areaCodes: [],
        flag: '/flags/cl.svg',
    },
    {
        countryName: 'China ',
        countryCode: 'cn',
        dialCode: '+86',
        areaCodes: [],
        flag: '/flags/cn.svg',
    },
    {
        countryName: 'Christmas Island',
        countryCode: 'cx',
        dialCode: '+61',
        areaCodes: ['89164'],
        flag: '/flags/cx.svg',
    },
    {
        countryName: 'Cocos  Islands',
        countryCode: 'cc',
        dialCode: '+61',
        areaCodes: ['89162'],
        flag: '/flags/cc.svg',
    },
    {
        countryName: 'Colombia',
        countryCode: 'co',
        dialCode: '+57',
        areaCodes: [],
        flag: '/flags/co.svg',
    },
    {
        countryName: 'Comoros ',
        countryCode: 'km',
        dialCode: '+269',
        areaCodes: [],
        flag: '/flags/km.svg',
    },
    {
        countryName: 'Congo ',
        countryCode: 'cd',
        dialCode: '+243',
        areaCodes: [],
        flag: '/flags/cd.svg',
    },
    {
        countryName: 'Congo ',
        countryCode: 'cg',
        dialCode: '+242',
        areaCodes: [],
        flag: '/flags/cg.svg',
    },
    {
        countryName: 'Cook Islands',
        countryCode: 'ck',
        dialCode: '+682',
        areaCodes: [],
        flag: '/flags/ck.svg',
    },
    {
        countryName: 'Costa Rica',
        countryCode: 'cr',
        dialCode: '+506',
        areaCodes: [],
        flag: '/flags/cr.svg',
    },
    {
        countryName: 'Côte d’Ivoire',
        countryCode: 'ci',
        dialCode: '+225',
        areaCodes: [],
        flag: '/flags/ci.svg',
    },
    {
        countryName: 'Croatia ',
        countryCode: 'hr',
        dialCode: '+385',
        areaCodes: [],
        flag: '/flags/hr.svg',
    },
    {
        countryName: 'Cuba',
        countryCode: 'cu',
        dialCode: '+53',
        areaCodes: [],
        flag: '/flags/cu.svg',
    },
    {
        countryName: 'Curaçao',
        countryCode: 'cw',
        dialCode: '+599',
        areaCodes: [],
        flag: '/flags/cw.svg',
    },
    {
        countryName: 'Cyprus ',
        countryCode: 'cy',
        dialCode: '+357',
        areaCodes: [],
        flag: '/flags/cy.svg',
    },
    {
        countryName: 'Czech Republic ',
        countryCode: 'cz',
        dialCode: '+420',
        areaCodes: [],
        flag: '/flags/cz.svg',
    },
    {
        countryName: 'Denmark ',
        countryCode: 'dk',
        dialCode: '+45',
        areaCodes: [],
        flag: '/flags/dk.svg',
    },
    {
        countryName: 'Djibouti',
        countryCode: 'dj',
        dialCode: '+253',
        areaCodes: [],
        flag: '/flags/dj.svg',
    },
    {
        countryName: 'Dominica',
        countryCode: 'dm',
        dialCode: '+1',
        areaCodes: ['767'],
        flag: '/flags/dm.svg',
    },
    {
        countryName: 'Dominican Republic ',
        countryCode: 'do',
        dialCode: '+1',
        areaCodes: ['809', '829', '849'],
        flag: '/flags/do.svg',
    },
    {
        countryName: 'Ecuador',
        countryCode: 'ec',
        dialCode: '+593',
        areaCodes: [],
        flag: '/flags/ec.svg',
    },
    {
        countryName: 'Egypt ',
        countryCode: 'eg',
        dialCode: '+20',
        areaCodes: [],
        flag: '/flags/eg.svg',
    },
    {
        countryName: 'El Salvador',
        countryCode: 'sv',
        dialCode: '+503',
        areaCodes: [],
        flag: '/flags/sv.svg',
    },
    {
        countryName: 'Equatorial Guinea ',
        countryCode: 'gq',
        dialCode: '+240',
        areaCodes: [],
        flag: '/flags/gq.svg',
    },
    {
        countryName: 'Eritrea',
        countryCode: 'er',
        dialCode: '+291',
        areaCodes: [],
        flag: '/flags/er.svg',
    },
    {
        countryName: 'Estonia ',
        countryCode: 'ee',
        dialCode: '+372',
        areaCodes: [],
        flag: '/flags/ee.svg',
    },
    {
        countryName: 'Eswatini',
        countryCode: 'sz',
        dialCode: '+268',
        areaCodes: [],
        flag: '/flags/sz.svg',
    },
    {
        countryName: 'Ethiopia',
        countryCode: 'et',
        dialCode: '+251',
        areaCodes: [],
        flag: '/flags/et.svg',
    },
    {
        countryName: 'Falkland Islands ',
        countryCode: 'fk',
        dialCode: '+500',
        areaCodes: [],
        flag: '/flags/fk.svg',
    },
    {
        countryName: 'Faroe Islands ',
        countryCode: 'fo',
        dialCode: '+298',
        areaCodes: [],
        flag: '/flags/fo.svg',
    },
    {
        countryName: 'Fiji',
        countryCode: 'fj',
        dialCode: '+679',
        areaCodes: [],
        flag: '/flags/fj.svg',
    },
    {
        countryName: 'Finland ',
        countryCode: 'fi',
        dialCode: '+358',
        areaCodes: [],
        flag: '/flags/fi.svg',
    },
    {
        countryName: 'France',
        countryCode: 'fr',
        dialCode: '+33',
        areaCodes: [],
        flag: '/flags/fr.svg',
    },
    {
        countryName: 'French Guiana ',
        countryCode: 'gf',
        dialCode: '+594',
        areaCodes: [],
        flag: '/flags/gf.svg',
    },
    {
        countryName: 'French Polynesia ',
        countryCode: 'pf',
        dialCode: '+689',
        areaCodes: [],
        flag: '/flags/pf.svg',
    },
    {
        countryName: 'Gabon',
        countryCode: 'ga',
        dialCode: '+241',
        areaCodes: [],
        flag: '/flags/ga.svg',
    },
    {
        countryName: 'Gambia',
        countryCode: 'gm',
        dialCode: '+220',
        areaCodes: [],
        flag: '/flags/gm.svg',
    },
    {
        countryName: 'Georgia ',
        countryCode: 'ge',
        dialCode: '+995',
        areaCodes: [],
        flag: '/flags/ge.svg',
    },
    {
        countryName: 'Germany ',
        countryCode: 'de',
        dialCode: '+49',
        areaCodes: [],
        flag: '/flags/de.svg',
    },
    {
        countryName: 'Ghana ',
        countryCode: 'gh',
        dialCode: '+233',
        areaCodes: [],
        flag: '/flags/gh.svg',
    },
    {
        countryName: 'Gibraltar',
        countryCode: 'gi',
        dialCode: '+350',
        areaCodes: [],
        flag: '/flags/gi.svg',
    },
    {
        countryName: 'Greece ',
        countryCode: 'gr',
        dialCode: '+30',
        areaCodes: [],
        flag: '/flags/gr.svg',
    },
    {
        countryName: 'Greenland ',
        countryCode: 'gl',
        dialCode: '+299',
        areaCodes: [],
        flag: '/flags/gl.svg',
    },
    {
        countryName: 'Grenada',
        countryCode: 'gd',
        dialCode: '+1',
        areaCodes: ['473'],
        flag: '/flags/gd.svg',
    },
    {
        countryName: 'Guadeloupe',
        countryCode: 'gp',
        dialCode: '+590',
        areaCodes: [],
        flag: '/flags/gp.svg',
    },
    {
        countryName: 'Guam',
        countryCode: 'gu',
        dialCode: '+1',
        areaCodes: ['671'],
        flag: '/flags/gu.svg',
    },
    {
        countryName: 'Guatemala',
        countryCode: 'gt',
        dialCode: '+502',
        areaCodes: [],
        flag: '/flags/gt.svg',
    },
    {
        countryName: 'Guernsey',
        countryCode: 'gg',
        dialCode: '+44',
        areaCodes: ['1481', '7781', '7839', '7911'],
        flag: '/flags/gg.svg',
    },
    {
        countryName: 'Guinea ',
        countryCode: 'gn',
        dialCode: '+224',
        areaCodes: [],
        flag: '/flags/gn.svg',
    },
    {
        countryName: 'Guinea-Bissau ',
        countryCode: 'gw',
        dialCode: '+245',
        areaCodes: [],
        flag: '/flags/gw.svg',
    },
    {
        countryName: 'Guyana',
        countryCode: 'gy',
        dialCode: '+592',
        areaCodes: [],
        flag: '/flags/gy.svg',
    },
    {
        countryName: 'Haiti',
        countryCode: 'ht',
        dialCode: '+509',
        areaCodes: [],
        flag: '/flags/ht.svg',
    },
    {
        countryName: 'Honduras',
        countryCode: 'hn',
        dialCode: '+504',
        areaCodes: [],
        flag: '/flags/hn.svg',
    },
    {
        countryName: 'Hong Kong ',
        countryCode: 'hk',
        dialCode: '+852',
        areaCodes: [],
        flag: '/flags/hk.svg',
    },
    {
        countryName: 'Hungary ',
        countryCode: 'hu',
        dialCode: '+36',
        areaCodes: [],
        flag: '/flags/hu.svg',
    },
    {
        countryName: 'Iceland ',
        countryCode: 'is',
        dialCode: '+354',
        areaCodes: [],
        flag: '/flags/is.svg',
    },
    {
        countryName: 'India ',
        countryCode: 'in',
        dialCode: '+91',
        areaCodes: [],
        flag: '/flags/in.svg',
    },
    {
        countryName: 'Indonesia',
        countryCode: 'id',
        dialCode: '+62',
        areaCodes: [],
        flag: '/flags/id.svg',
    },
    {
        countryName: 'Iran ',
        countryCode: 'ir',
        dialCode: '+98',
        areaCodes: [],
        flag: '/flags/ir.svg',
    },
    {
        countryName: 'Iraq ',
        countryCode: 'iq',
        dialCode: '+964',
        areaCodes: [],
        flag: '/flags/iq.svg',
    },
    {
        countryName: 'Ireland',
        countryCode: 'ie',
        dialCode: '+353',
        areaCodes: [],
        flag: '/flags/ie.svg',
    },
    {
        countryName: 'Isle of Man',
        countryCode: 'im',
        dialCode: '+44',
        areaCodes: ['1624', '74576', '7524', '7924', '7624'],
        flag: '/flags/im.svg',
    },
    {
        countryName: 'Israel ',
        countryCode: 'il',
        dialCode: '+972',
        areaCodes: [],
        flag: '/flags/il.svg',
    },
    {
        countryName: 'Italy ',
        countryCode: 'it',
        dialCode: '+39',
        areaCodes: [],
        flag: '/flags/it.svg',
    },
    {
        countryName: 'Jamaica',
        countryCode: 'jm',
        dialCode: '+1',
        areaCodes: ['876', '658'],
        flag: '/flags/jm.svg',
    },
    {
        countryName: 'Japan ',
        countryCode: 'jp',
        dialCode: '+81',
        areaCodes: [],
        flag: '/flags/jp.svg',
    },
    {
        countryName: 'Jersey',
        countryCode: 'je',
        dialCode: '+44',
        areaCodes: ['1534', '7509', '7700', '7797', '7829', '7937'],
        flag: '/flags/je.svg',
    },
    {
        countryName: 'Jordan ',
        countryCode: 'jo',
        dialCode: '+962',
        areaCodes: [],
        flag: '/flags/jo.svg',
    },
    {
        countryName: 'Kazakhstan ',
        countryCode: 'kz',
        dialCode: '+7',
        areaCodes: ['33', '7'],
        flag: '/flags/kz.svg',
    },
    {
        countryName: 'Kenya',
        countryCode: 'ke',
        dialCode: '+254',
        areaCodes: [],
        flag: '/flags/ke.svg',
    },
    {
        countryName: 'Kiribati',
        countryCode: 'ki',
        dialCode: '+686',
        areaCodes: [],
        flag: '/flags/ki.svg',
    },
    {
        countryName: 'Kosovo',
        countryCode: 'xk',
        dialCode: '+383',
        areaCodes: [],
        flag: '/flags/xk.svg',
    },
    {
        countryName: 'Kuwait ',
        countryCode: 'kw',
        dialCode: '+965',
        areaCodes: [],
        flag: '/flags/kw.svg',
    },
    {
        countryName: 'Kyrgyzstan ',
        countryCode: 'kg',
        dialCode: '+996',
        areaCodes: [],
        flag: '/flags/kg.svg',
    },
    {
        countryName: 'Laos ',
        countryCode: 'la',
        dialCode: '+856',
        areaCodes: [],
        flag: '/flags/la.svg',
    },
    {
        countryName: 'Latvia ',
        countryCode: 'lv',
        dialCode: '+371',
        areaCodes: [],
        flag: '/flags/lv.svg',
    },
    {
        countryName: 'Lebanon ',
        countryCode: 'lb',
        dialCode: '+961',
        areaCodes: [],
        flag: '/flags/lb.svg',
    },
    {
        countryName: 'Lesotho',
        countryCode: 'ls',
        dialCode: '+266',
        areaCodes: [],
        flag: '/flags/ls.svg',
    },
    {
        countryName: 'Liberia',
        countryCode: 'lr',
        dialCode: '+231',
        areaCodes: [],
        flag: '/flags/lr.svg',
    },
    {
        countryName: 'Libya ',
        countryCode: 'ly',
        dialCode: '+218',
        areaCodes: [],
        flag: '/flags/ly.svg',
    },
    {
        countryName: 'Liechtenstein',
        countryCode: 'li',
        dialCode: '+423',
        areaCodes: [],
        flag: '/flags/li.svg',
    },
    {
        countryName: 'Lithuania ',
        countryCode: 'lt',
        dialCode: '+370',
        areaCodes: [],
        flag: '/flags/lt.svg',
    },
    {
        countryName: 'Luxembourg',
        countryCode: 'lu',
        dialCode: '+352',
        areaCodes: [],
        flag: '/flags/lu.svg',
    },
    {
        countryName: 'Macau ',
        countryCode: 'mo',
        dialCode: '+853',
        areaCodes: [],
        flag: '/flags/mo.svg',
    },
    {
        countryName: 'Madagascar ',
        countryCode: 'mg',
        dialCode: '+261',
        areaCodes: [],
        flag: '/flags/mg.svg',
    },
    {
        countryName: 'Malawi',
        countryCode: 'mw',
        dialCode: '+265',
        areaCodes: [],
        flag: '/flags/mw.svg',
    },
    {
        countryName: 'Malaysia',
        countryCode: 'my',
        dialCode: '+60',
        areaCodes: [],
        flag: '/flags/my.svg',
    },
    {
        countryName: 'Maldives',
        countryCode: 'mv',
        dialCode: '+960',
        areaCodes: [],
        flag: '/flags/mv.svg',
    },
    {
        countryName: 'Mali',
        countryCode: 'ml',
        dialCode: '+223',
        areaCodes: [],
        flag: '/flags/ml.svg',
    },
    {
        countryName: 'Malta',
        countryCode: 'mt',
        dialCode: '+356',
        areaCodes: [],
        flag: '/flags/mt.svg',
    },
    {
        countryName: 'Marshall Islands',
        countryCode: 'mh',
        dialCode: '+692',
        areaCodes: [],
        flag: '/flags/mh.svg',
    },
    {
        countryName: 'Martinique',
        countryCode: 'mq',
        dialCode: '+596',
        areaCodes: [],
        flag: '/flags/mq.svg',
    },
    {
        countryName: 'Mauritania ',
        countryCode: 'mr',
        dialCode: '+222',
        areaCodes: [],
        flag: '/flags/mr.svg',
    },
    {
        countryName: 'Mauritius ',
        countryCode: 'mu',
        dialCode: '+230',
        areaCodes: [],
        flag: '/flags/mu.svg',
    },
    {
        countryName: 'Mayotte',
        countryCode: 'yt',
        dialCode: '+262',
        areaCodes: ['269', '639'],
        flag: '/flags/yt.svg',
    },
    {
        countryName: 'Mexico ',
        countryCode: 'mx',
        dialCode: '+52',
        areaCodes: [],
        flag: '/flags/mx.svg',
    },
    {
        countryName: 'Micronesia',
        countryCode: 'fm',
        dialCode: '+691',
        areaCodes: [],
        flag: '/flags/fm.svg',
    },
    {
        countryName: 'Moldova ',
        countryCode: 'md',
        dialCode: '+373',
        areaCodes: [],
        flag: '/flags/md.svg',
    },
    {
        countryName: 'Monaco',
        countryCode: 'mc',
        dialCode: '+377',
        areaCodes: [],
        flag: '/flags/mc.svg',
    },
    {
        countryName: 'Mongolia ',
        countryCode: 'mn',
        dialCode: '+976',
        areaCodes: [],
        flag: '/flags/mn.svg',
    },
    {
        countryName: 'Montenegro ',
        countryCode: 'me',
        dialCode: '+382',
        areaCodes: [],
        flag: '/flags/me.svg',
    },
    {
        countryName: 'Montserrat',
        countryCode: 'ms',
        dialCode: '+1',
        areaCodes: ['664'],
        flag: '/flags/ms.svg',
    },
    {
        countryName: 'Morocco ',
        countryCode: 'ma',
        dialCode: '+212',
        areaCodes: [],
        flag: '/flags/ma.svg',
    },
    {
        countryName: 'Mozambique ',
        countryCode: 'mz',
        dialCode: '+258',
        areaCodes: [],
        flag: '/flags/mz.svg',
    },
    {
        countryName: 'Myanmar ',
        countryCode: 'mm',
        dialCode: '+95',
        areaCodes: [],
        flag: '/flags/mm.svg',
    },
    {
        countryName: 'Namibia ',
        countryCode: 'na',
        dialCode: '+264',
        areaCodes: [],
        flag: '/flags/na.svg',
    },
    {
        countryName: 'Nauru',
        countryCode: 'nr',
        dialCode: '+674',
        areaCodes: [],
        flag: '/flags/nr.svg',
    },
    {
        countryName: 'Nepal ',
        countryCode: 'np',
        dialCode: '+977',
        areaCodes: [],
        flag: '/flags/np.svg',
    },
    {
        countryName: 'Netherlands ',
        countryCode: 'nl',
        dialCode: '+31',
        areaCodes: [],
        flag: '/flags/nl.svg',
    },
    {
        countryName: 'New Caledonia ',
        countryCode: 'nc',
        dialCode: '+687',
        areaCodes: [],
        flag: '/flags/nc.svg',
    },
    {
        countryName: 'New Zealand',
        countryCode: 'nz',
        dialCode: '+64',
        areaCodes: [],
        flag: '/flags/nz.svg',
    },
    {
        countryName: 'Nicaragua',
        countryCode: 'ni',
        dialCode: '+505',
        areaCodes: [],
        flag: '/flags/ni.svg',
    },
    {
        countryName: 'Niger ',
        countryCode: 'ne',
        dialCode: '+227',
        areaCodes: [],
        flag: '/flags/ne.svg',
    },
    {
        countryName: 'Nigeria',
        countryCode: 'ng',
        dialCode: '+234',
        areaCodes: [],
        flag: '/flags/ng.svg',
    },
    {
        countryName: 'Niue',
        countryCode: 'nu',
        dialCode: '+683',
        areaCodes: [],
        flag: '/flags/nu.svg',
    },
    {
        countryName: 'Norfolk Island',
        countryCode: 'nf',
        dialCode: '+672',
        areaCodes: [],
        flag: '/flags/nf.svg',
    },
    {
        countryName: 'North Korea ',
        countryCode: 'kp',
        dialCode: '+850',
        areaCodes: [],
        flag: '/flags/kp.svg',
    },
    {
        countryName: 'North Macedonia ',
        countryCode: 'mk',
        dialCode: '+389',
        areaCodes: [],
        flag: '/flags/mk.svg',
    },
    {
        countryName: 'Northern Mariana Islands',
        countryCode: 'mp',
        dialCode: '+1',
        areaCodes: ['670'],
        flag: '/flags/mp.svg',
    },
    {
        countryName: 'Norway ',
        countryCode: 'no',
        dialCode: '+47',
        areaCodes: [],
        flag: '/flags/no.svg',
    },
    {
        countryName: 'Oman ',
        countryCode: 'om',
        dialCode: '+968',
        areaCodes: [],
        flag: '/flags/om.svg',
    },
    {
        countryName: 'Pakistan ',
        countryCode: 'pk',
        dialCode: '+92',
        areaCodes: [],
        flag: '/flags/pk.svg',
    },
    {
        countryName: 'Palau',
        countryCode: 'pw',
        dialCode: '+680',
        areaCodes: [],
        flag: '/flags/pw.svg',
    },
    {
        countryName: 'Palestine ',
        countryCode: 'ps',
        dialCode: '+970',
        areaCodes: [],
        flag: '/flags/ps.svg',
    },
    {
        countryName: 'Panama ',
        countryCode: 'pa',
        dialCode: '+507',
        areaCodes: [],
        flag: '/flags/pa.svg',
    },
    {
        countryName: 'Papua New Guinea',
        countryCode: 'pg',
        dialCode: '+675',
        areaCodes: [],
        flag: '/flags/pg.svg',
    },
    {
        countryName: 'Paraguay',
        countryCode: 'py',
        dialCode: '+595',
        areaCodes: [],
        flag: '/flags/py.svg',
    },
    {
        countryName: 'Peru ',
        countryCode: 'pe',
        dialCode: '+51',
        areaCodes: [],
        flag: '/flags/pe.svg',
    },
    {
        countryName: 'Philippines',
        countryCode: 'ph',
        dialCode: '+63',
        areaCodes: [],
        flag: '/flags/ph.svg',
    },
    {
        countryName: 'Poland ',
        countryCode: 'pl',
        dialCode: '+48',
        areaCodes: [],
        flag: '/flags/pl.svg',
    },
    {
        countryName: 'Portugal',
        countryCode: 'pt',
        dialCode: '+351',
        areaCodes: [],
        flag: '/flags/pt.svg',
    },
    {
        countryName: 'Puerto Rico',
        countryCode: 'pr',
        dialCode: '+1',
        areaCodes: ['787', '939'],
        flag: '/flags/pr.svg',
    },
    {
        countryName: 'Qatar ',
        countryCode: 'qa',
        dialCode: '+974',
        areaCodes: [],
        flag: '/flags/qa.svg',
    },
    {
        countryName: 'Réunion ',
        countryCode: 're',
        dialCode: '+262',
        areaCodes: [],
        flag: '/flags/re.svg',
    },
    {
        countryName: 'Romania ',
        countryCode: 'ro',
        dialCode: '+40',
        areaCodes: [],
        flag: '/flags/ro.svg',
    },
    {
        countryName: 'Russia ',
        countryCode: 'ru',
        dialCode: '+7',
        areaCodes: [],
        flag: '/flags/ru.svg',
    },
    {
        countryName: 'Rwanda',
        countryCode: 'rw',
        dialCode: '+250',
        areaCodes: [],
        flag: '/flags/rw.svg',
    },
    {
        countryName: 'Saint Barthélemy',
        countryCode: 'bl',
        dialCode: '+590',
        areaCodes: [],
        flag: '/flags/bl.svg',
    },
    {
        countryName: 'Saint Helena',
        countryCode: 'sh',
        dialCode: '+290',
        areaCodes: [],
        flag: '/flags/sh.svg',
    },
    {
        countryName: 'Saint Kitts and Nevis',
        countryCode: 'kn',
        dialCode: '+1',
        areaCodes: ['869'],
        flag: '/flags/kn.svg',
    },
    {
        countryName: 'Saint Lucia',
        countryCode: 'lc',
        dialCode: '+1',
        areaCodes: ['758'],
        flag: '/flags/lc.svg',
    },
    {
        countryName: 'Saint Martin ',
        countryCode: 'mf',
        dialCode: '+590',
        areaCodes: [],
        flag: '/flags/mf.svg',
    },
    {
        countryName: 'Saint Pierre and Miquelon ',
        countryCode: 'pm',
        dialCode: '+508',
        areaCodes: [],
        flag: '/flags/pm.svg',
    },
    {
        countryName: 'Saint Vincent and the Grenadines',
        countryCode: 'vc',
        dialCode: '+1',
        areaCodes: ['784'],
        flag: '/flags/vc.svg',
    },
    {
        countryName: 'Samoa',
        countryCode: 'ws',
        dialCode: '+685',
        areaCodes: [],
        flag: '/flags/ws.svg',
    },
    {
        countryName: 'San Marino',
        countryCode: 'sm',
        dialCode: '+378',
        areaCodes: [],
        flag: '/flags/sm.svg',
    },
    {
        countryName: 'São Tomé and Príncipe ',
        countryCode: 'st',
        dialCode: '+239',
        areaCodes: [],
        flag: '/flags/st.svg',
    },
    {
        countryName: 'Saudi Arabia ',
        countryCode: 'sa',
        dialCode: '+966',
        areaCodes: [],
        flag: '/flags/sa.svg',
    },
    {
        countryName: 'Senegal ',
        countryCode: 'sn',
        dialCode: '+221',
        areaCodes: [],
        flag: '/flags/sn.svg',
    },
    {
        countryName: 'Serbia ',
        countryCode: 'rs',
        dialCode: '+381',
        areaCodes: [],
        flag: '/flags/rs.svg',
    },
    {
        countryName: 'Seychelles',
        countryCode: 'sc',
        dialCode: '+248',
        areaCodes: [],
        flag: '/flags/sc.svg',
    },
    {
        countryName: 'Sierra Leone',
        countryCode: 'sl',
        dialCode: '+232',
        areaCodes: [],
        flag: '/flags/sl.svg',
    },
    {
        countryName: 'Singapore',
        countryCode: 'sg',
        dialCode: '+65',
        areaCodes: [],
        flag: '/flags/sg.svg',
    },
    {
        countryName: 'Sint Maarten',
        countryCode: 'sx',
        dialCode: '+1',
        areaCodes: ['721'],
        flag: '/flags/sx.svg',
    },
    {
        countryName: 'Slovakia ',
        countryCode: 'sk',
        dialCode: '+421',
        areaCodes: [],
        flag: '/flags/sk.svg',
    },
    {
        countryName: 'Slovenia ',
        countryCode: 'si',
        dialCode: '+386',
        areaCodes: [],
        flag: '/flags/si.svg',
    },
    {
        countryName: 'Solomon Islands',
        countryCode: 'sb',
        dialCode: '+677',
        areaCodes: [],
        flag: '/flags/sb.svg',
    },
    {
        countryName: 'Somalia ',
        countryCode: 'so',
        dialCode: '+252',
        areaCodes: [],
        flag: '/flags/so.svg',
    },
    {
        countryName: 'South Africa',
        countryCode: 'za',
        dialCode: '+27',
        areaCodes: [],
        flag: '/flags/za.svg',
    },
    {
        countryName: 'South Korea ',
        countryCode: 'kr',
        dialCode: '+82',
        areaCodes: [],
        flag: '/flags/kr.svg',
    },
    {
        countryName: 'South Sudan ',
        countryCode: 'ss',
        dialCode: '+211',
        areaCodes: [],
        flag: '/flags/ss.svg',
    },
    {
        countryName: 'Spain ',
        countryCode: 'es',
        dialCode: '+34',
        areaCodes: [],
        flag: '/flags/es.svg',
    },
    {
        countryName: 'Sri Lanka ',
        countryCode: 'lk',
        dialCode: '+94',
        areaCodes: [],
        flag: '/flags/lk.svg',
    },
    {
        countryName: 'Sudan ',
        countryCode: 'sd',
        dialCode: '+249',
        areaCodes: [],
        flag: '/flags/sd.svg',
    },
    {
        countryName: 'Suriname',
        countryCode: 'sr',
        dialCode: '+597',
        areaCodes: [],
        flag: '/flags/sr.svg',
    },
    {
        countryName: 'Svalbard and Jan Mayen',
        countryCode: 'sj',
        dialCode: '+47',
        areaCodes: ['79'],
        flag: '/flags/sj.svg',
    },
    {
        countryName: 'Sweden ',
        countryCode: 'se',
        dialCode: '+46',
        areaCodes: [],
        flag: '/flags/se.svg',
    },
    {
        countryName: 'Switzerland ',
        countryCode: 'ch',
        dialCode: '+41',
        areaCodes: [],
        flag: '/flags/ch.svg',
    },
    {
        countryName: 'Syria ',
        countryCode: 'sy',
        dialCode: '+963',
        areaCodes: [],
        flag: '/flags/sy.svg',
    },
    {
        countryName: 'Taiwan ',
        countryCode: 'tw',
        dialCode: '+886',
        areaCodes: [],
        flag: '/flags/tw.svg',
    },
    {
        countryName: 'Tajikistan',
        countryCode: 'tj',
        dialCode: '+992',
        areaCodes: [],
        flag: '/flags/tj.svg',
    },
    {
        countryName: 'Tanzania',
        countryCode: 'tz',
        dialCode: '+255',
        areaCodes: [],
        flag: '/flags/tz.svg',
    },
    {
        countryName: 'Thailand ',
        countryCode: 'th',
        dialCode: '+66',
        areaCodes: [],
        flag: '/flags/th.svg',
    },
    {
        countryName: 'Timor-Leste',
        countryCode: 'tl',
        dialCode: '+670',
        areaCodes: [],
        flag: '/flags/tl.svg',
    },
    {
        countryName: 'Togo',
        countryCode: 'tg',
        dialCode: '+228',
        areaCodes: [],
        flag: '/flags/tg.svg',
    },
    {
        countryName: 'Tokelau',
        countryCode: 'tk',
        dialCode: '+690',
        areaCodes: [],
        flag: '/flags/tk.svg',
    },
    {
        countryName: 'Tonga',
        countryCode: 'to',
        dialCode: '+676',
        areaCodes: [],
        flag: '/flags/to.svg',
    },
    {
        countryName: 'Trinidad and Tobago',
        countryCode: 'tt',
        dialCode: '+1',
        areaCodes: ['868'],
        flag: '/flags/tt.svg',
    },
    {
        countryName: 'Tunisia ',
        countryCode: 'tn',
        dialCode: '+216',
        areaCodes: [],
        flag: '/flags/tn.svg',
    },
    {
        countryName: 'Turkey ',
        countryCode: 'tr',
        dialCode: '+90',
        areaCodes: [],
        flag: '/flags/tr.svg',
    },
    {
        countryName: 'Turkmenistan',
        countryCode: 'tm',
        dialCode: '+993',
        areaCodes: [],
        flag: '/flags/tm.svg',
    },
    {
        countryName: 'Turks and Caicos Islands',
        countryCode: 'tc',
        dialCode: '+1',
        areaCodes: ['649'],
        flag: '/flags/tc.svg',
    },
    {
        countryName: 'Tuvalu',
        countryCode: 'tv',
        dialCode: '+688',
        areaCodes: [],
        flag: '/flags/tv.svg',
    },
    {
        countryName: 'U.S. Virgin Islands',
        countryCode: 'vi',
        dialCode: '+1',
        areaCodes: ['340'],
        flag: '/flags/vi.svg',
    },
    {
        countryName: 'Uganda',
        countryCode: 'ug',
        dialCode: '+256',
        areaCodes: [],
        flag: '/flags/ug.svg',
    },
    {
        countryName: 'Ukraine ',
        countryCode: 'ua',
        dialCode: '+380',
        areaCodes: [],
        flag: '/flags/ua.svg',
    },
    {
        countryName: 'United Arab Emirates ',
        countryCode: 'ae',
        dialCode: '+971',
        areaCodes: [],
        flag: '/flags/ae.svg',
    },
    {
        countryName: 'United Kingdom',
        countryCode: 'gb',
        dialCode: '+44',
        areaCodes: [],
        flag: '/flags/gb.svg',
    },
    {
        countryName: 'United States',
        countryCode: 'us',
        dialCode: '+1',
        areaCodes: [],
        flag: '/flags/us.svg',
    },
    {
        countryName: 'Uruguay',
        countryCode: 'uy',
        dialCode: '+598',
        areaCodes: [],
        flag: '/flags/uy.svg',
    },
    {
        countryName: 'Uzbekistan ',
        countryCode: 'uz',
        dialCode: '+998',
        areaCodes: [],
        flag: '/flags/uz.svg',
    },
    {
        countryName: 'Vanuatu',
        countryCode: 'vu',
        dialCode: '+678',
        areaCodes: [],
        flag: '/flags/vu.svg',
    },
    {
        countryName: 'Vatican City ',
        countryCode: 'va',
        dialCode: '+39',
        areaCodes: ['06698'],
        flag: '/flags/va.svg',
    },
    {
        countryName: 'Venezuela',
        countryCode: 've',
        dialCode: '+58',
        areaCodes: [],
        flag: '/flags/ve.svg',
    },
    {
        countryName: 'Vietnam ',
        countryCode: 'vn',
        dialCode: '+84',
        areaCodes: [],
        flag: '/flags/vn.svg',
    },
    {
        countryName: 'Wallis and Futuna ',
        countryCode: 'wf',
        dialCode: '+681',
        areaCodes: [],
        flag: '/flags/wf.svg',
    },
    {
        countryName: 'Western Sahara ',
        countryCode: 'eh',
        dialCode: '+212',
        areaCodes: ['5288', '5289'],
        flag: '/flags/eh.svg',
    },
    {
        countryName: 'Yemen ',
        countryCode: 'ye',
        dialCode: '+967',
        areaCodes: [],
        flag: '/flags/ye.svg',
    },
    {
        countryName: 'Zambia',
        countryCode: 'zm',
        dialCode: '+260',
        areaCodes: [],
        flag: '/flags/zm.svg',
    },
    {
        countryName: 'Zimbabwe',
        countryCode: 'zw',
        dialCode: '+263',
        areaCodes: [],
        flag: '/flags/zw.svg',
    },
    {
        countryName: 'Åland Islands',
        countryCode: 'ax',
        dialCode: '+358',
        areaCodes: ['18'],
        flag: '/flags/ax.svg',
    },
];

export const timezoneList = [
    {
        label: 'Please Select Timezone',
        value: '',
    },
    {
        label: 'Midway Island (UTC-11:00)',
        value: 'Pacific/Midway',
    },
    {
        label: 'Samoa (UTC-11:00)',
        value: 'Pacific/Samoa',
    },
    {
        label: 'Hawaii (UTC-10:00)',
        value: 'Pacific/Honolulu',
    },
    {
        label: 'Alaska (UTC-09:00)',
        value: 'US/Alaska',
    },
    {
        label: 'Pacific Time (US & Canada) (UTC-08:00)',
        value: 'America/Los_Angeles',
    },
    {
        label: 'Tijuana (UTC-08:00)',
        value: 'America/Tijuana',
    },
    {
        label: 'Arizona (UTC-07:00)',
        value: 'US/Arizona',
    },
    {
        label: 'Chihuahua (UTC-07:00)',
        value: 'America/Chihuahua',
    },
    {
        label: 'La Paz (UTC-07:00)',
        value: 'America/Chihuahua',
    },
    {
        label: 'Mazatlan (UTC-07:00)',
        value: 'America/Mazatlan',
    },
    {
        label: 'Mountain Time (US & Canada) (UTC-07:00)',
        value: 'US/Mountain',
    },
    {
        label: 'Central America (UTC-06:00)',
        value: 'America/Managua',
    },
    {
        label: 'Central Time (US & Canada) (UTC-06:00)',
        value: 'US/Central',
    },
    {
        label: 'Guadalajara (UTC-06:00)',
        value: 'America/Mexico_City',
    },
    {
        label: 'Mexico City (UTC-06:00)',
        value: 'America/Mexico_City',
    },
    {
        label: 'Monterrey (UTC-06:00)',
        value: 'America/Monterrey',
    },
    {
        label: 'Saskatchewan (UTC-06:00)',
        value: 'Canada/Saskatchewan',
    },
    {
        label: 'Bogota (UTC-05:00)',
        value: 'America/Bogota',
    },
    {
        label: 'Eastern Time (US & Canada) (UTC-05:00)',
        value: 'US/Eastern',
    },
    {
        label: 'Indiana (East) (UTC-05:00)',
        value: 'US/East-Indiana',
    },
    {
        label: 'Lima (UTC-05:00)',
        value: 'America/Lima',
    },
    {
        label: 'Quito (UTC-05:00)',
        value: 'America/Bogota',
    },
    {
        label: 'Atlantic Time (Canada) (UTC-04:00)',
        value: 'Canada/Atlantic',
    },
    {
        label: 'Caracas (UTC-04:30)',
        value: 'America/Caracas',
    },
    {
        label: 'La Paz (UTC-04:00)',
        value: 'America/La_Paz',
    },
    {
        label: 'Santiago (UTC-04:00)',
        value: 'America/Santiago',
    },
    {
        label: 'Newfoundland (UTC-03:30)',
        value: 'Canada/Newfoundland',
    },
    {
        label: 'Brasilia (UTC-03:00)',
        value: 'America/Sao_Paulo',
    },
    {
        label: 'Buenos Aires (UTC-03:00)',
        value: 'America/Argentina/Buenos_Aires',
    },
    {
        label: 'Georgetown (UTC-03:00)',
        value: 'America/Argentina/Buenos_Aires',
    },
    {
        label: 'Greenland (UTC-03:00)',
        value: 'America/Godthab',
    },
    {
        label: 'Mid-Atlantic (UTC-02:00)',
        value: 'America/Noronha',
    },
    {
        label: 'Azores (UTC-01:00)',
        value: 'Atlantic/Azores',
    },
    {
        label: 'Cape Verde Is. (UTC-01:00)',
        value: 'Atlantic/Cape_Verde',
    },
    {
        label: 'Casablanca (UTC+00:00)',
        value: 'Africa/Casablanca',
    },
    {
        label: 'Edinburgh (UTC+00:00)',
        value: 'Europe/London',
    },
    {
        label: 'Greenwich Mean Time : Dublin (UTC+00:00)',
        value: 'Etc/Greenwich',
    },
    {
        label: 'Lisbon (UTC+00:00)',
        value: 'Europe/Lisbon',
    },
    {
        label: 'London (UTC+00:00)',
        value: 'Europe/London',
    },
    {
        label: 'Monrovia (UTC+00:00)',
        value: 'Africa/Monrovia',
    },
    {
        label: 'UTC (UTC+00:00)',
        value: 'UTC',
    },
    {
        label: 'Amsterdam (UTC+01:00)',
        value: 'Europe/Amsterdam',
    },
    {
        label: 'Belgrade (UTC+01:00)',
        value: 'Europe/Belgrade',
    },
    {
        label: 'Berlin (UTC+01:00)',
        value: 'Europe/Berlin',
    },
    {
        label: 'Bern (UTC+01:00)',
        value: 'Europe/Berlin',
    },
    {
        label: 'Bratislava (UTC+01:00)',
        value: 'Europe/Bratislava',
    },
    {
        label: 'Brussels (UTC+01:00)',
        value: 'Europe/Brussels',
    },
    {
        label: 'Budapest (UTC+01:00)',
        value: 'Europe/Budapest',
    },
    {
        label: 'Copenhagen (UTC+01:00)',
        value: 'Europe/Copenhagen',
    },
    {
        label: 'Ljubljana (UTC+01:00)',
        value: 'Europe/Ljubljana',
    },
    {
        label: 'Madrid (UTC+01:00)',
        value: 'Europe/Madrid',
    },
    {
        label: 'Paris (UTC+01:00)',
        value: 'Europe/Paris',
    },
    {
        label: 'Prague (UTC+01:00)',
        value: 'Europe/Prague',
    },
    {
        label: 'Rome (UTC+01:00)',
        value: 'Europe/Rome',
    },
    {
        label: 'Sarajevo (UTC+01:00)',
        value: 'Europe/Sarajevo',
    },
    {
        label: 'Skopje (UTC+01:00)',
        value: 'Europe/Skopje',
    },
    {
        label: 'Stockholm (UTC+01:00)',
        value: 'Europe/Stockholm',
    },
    {
        label: 'Vienna (UTC+01:00)',
        value: 'Europe/Vienna',
    },
    {
        label: 'Warsaw (UTC+01:00)',
        value: 'Europe/Warsaw',
    },
    {
        label: 'West Central Africa (UTC+01:00)',
        value: 'Africa/Lagos',
    },
    {
        label: 'Zagreb (UTC+01:00)',
        value: 'Europe/Zagreb',
    },
    {
        label: 'Athens (UTC+02:00)',
        value: 'Europe/Athens',
    },
    {
        label: 'Bucharest (UTC+02:00)',
        value: 'Europe/Bucharest',
    },
    {
        label: 'Cairo (UTC+02:00)',
        value: 'Africa/Cairo',
    },
    {
        label: 'Harare (UTC+02:00)',
        value: 'Africa/Harare',
    },
    {
        label: 'Helsinki (UTC+02:00)',
        value: 'Europe/Helsinki',
    },
    {
        label: 'Istanbul (UTC+02:00)',
        value: 'Europe/Istanbul',
    },
    {
        label: 'Jerusalem (UTC+02:00)',
        value: 'Asia/Jerusalem',
    },
    {
        label: 'Kyiv (UTC+02:00)',
        value: 'Europe/Helsinki',
    },
    {
        label: 'Pretoria (UTC+02:00)',
        value: 'Africa/Johannesburg',
    },
    {
        label: 'Riga (UTC+02:00)',
        value: 'Europe/Riga',
    },
    {
        label: 'Sofia (UTC+02:00)',
        value: 'Europe/Sofia',
    },
    {
        label: 'Tallinn (UTC+02:00)',
        value: 'Europe/Tallinn',
    },
    {
        label: 'Vilnius (UTC+02:00)',
        value: 'Europe/Vilnius',
    },
    {
        label: 'Baghdad (UTC+03:00)',
        value: 'Asia/Baghdad',
    },
    {
        label: 'Kuwait (UTC+03:00)',
        value: 'Asia/Kuwait',
    },
    {
        label: 'Minsk (UTC+03:00)',
        value: 'Europe/Minsk',
    },
    {
        label: 'Nairobi (UTC+03:00)',
        value: 'Africa/Nairobi',
    },
    {
        label: 'Riyadh (UTC+03:00)',
        value: 'Asia/Riyadh',
    },
    {
        label: 'Volgograd (UTC+03:00)',
        value: 'Europe/Volgograd',
    },
    {
        label: 'Tehran (UTC+03:30)',
        value: 'Asia/Tehran',
    },
    {
        label: 'Abu Dhabi (UTC+04:00)',
        value: 'Asia/Muscat',
    },
    {
        label: 'Baku (UTC+04:00)',
        value: 'Asia/Baku',
    },
    {
        label: 'Moscow (UTC+04:00)',
        value: 'Europe/Moscow',
    },
    {
        label: 'Muscat (UTC+04:00)',
        value: 'Asia/Muscat',
    },
    {
        label: 'St. Petersburg (UTC+04:00)',
        value: 'Europe/Moscow',
    },
    {
        label: 'Tbilisi (UTC+04:00)',
        value: 'Asia/Tbilisi',
    },
    {
        label: 'Dubai (UTC+04:00)',
        value: 'Asia/Dubai',
    },
    {
        label: 'Yerevan (UTC+04:00)',
        value: 'Asia/Yerevan',
    },
    {
        label: 'Kabul (UTC+04:30)',
        value: 'Asia/Kabul',
    },
    {
        label: 'Islamabad (UTC+05:00)',
        value: 'Asia/Karachi',
    },
    {
        label: 'Karachi (UTC+05:00)',
        value: 'Asia/Karachi',
    },
    {
        label: 'Tashkent (UTC+05:00)',
        value: 'Asia/Tashkent',
    },
    {
        label: 'Kolkata (UTC+05:30)',
        value: 'Asia/Kolkata',
    },
    {
        label: 'Kathmandu (UTC+05:45)',
        value: 'Asia/Katmandu',
    },
    {
        label: 'Almaty (UTC+06:00)',
        value: 'Asia/Almaty',
    },
    {
        label: 'Astana (UTC+06:00)',
        value: 'Asia/Dhaka',
    },
    {
        label: 'Dhaka (UTC+06:00)',
        value: 'Asia/Dhaka',
    },
    {
        label: 'Ekaterinburg (UTC+06:00)',
        value: 'Asia/Yekaterinburg',
    },
    {
        label: 'Rangoon (UTC+06:30)',
        value: 'Asia/Rangoon',
    },
    {
        label: 'Bangkok (UTC+07:00)',
        value: 'Asia/Bangkok',
    },
    {
        label: 'Jakarta (UTC+07:00)',
        value: 'Asia/Jakarta',
    },
    {
        label: 'Novosibirsk (UTC+07:00)',
        value: 'Asia/Novosibirsk',
    },
    {
        label: 'Beijing (UTC+08:00)',
        value: 'Asia/Hong_Kong',
    },
    {
        label: 'Chongqing (UTC+08:00)',
        value: 'Asia/Chongqing',
    },
    {
        label: 'Hong Kong (UTC+08:00)',
        value: 'Asia/Hong_Kong',
    },
    {
        label: 'Krasnoyarsk (UTC+08:00)',
        value: 'Asia/Krasnoyarsk',
    },
    {
        label: 'Kuala Lumpur (UTC+08:00)',
        value: 'Asia/Kuala_Lumpur',
    },
    {
        label: 'Perth (UTC+08:00)',
        value: 'Australia/Perth',
    },
    {
        label: 'Singapore (UTC+08:00)',
        value: 'Asia/Singapore',
    },
    {
        label: 'Taipei (UTC+08:00)',
        value: 'Asia/Taipei',
    },
    {
        label: 'Ulaan Bataar (UTC+08:00)',
        value: 'Asia/Ulan_Bator',
    },
    {
        label: 'Urumqi (UTC+08:00)',
        value: 'Asia/Urumqi',
    },
    {
        label: 'Irkutsk (UTC+09:00)',
        value: 'Asia/Irkutsk',
    },
    {
        label: 'Osaka (UTC+09:00)',
        value: 'Asia/Tokyo',
    },
    {
        label: 'Sapporo (UTC+09:00)',
        value: 'Asia/Tokyo',
    },
    {
        label: 'Seoul (UTC+09:00)',
        value: 'Asia/Seoul',
    },
    {
        label: 'Tokyo (UTC+09:00)',
        value: 'Asia/Tokyo',
    },
    {
        label: 'Adelaide (UTC+09:30)',
        value: 'Australia/Adelaide',
    },
    {
        label: 'Darwin (UTC+09:30)',
        value: 'Australia/Darwin',
    },
    {
        label: 'Brisbane (UTC+10:00)',
        value: 'Australia/Brisbane',
    },
    {
        label: 'Canberra (UTC+10:00)',
        value: 'Australia/Canberra',
    },
    {
        label: 'Guam (UTC+10:00)',
        value: 'Pacific/Guam',
    },
    {
        label: 'Hobart (UTC+10:00)',
        value: 'Australia/Hobart',
    },
    {
        label: 'Melbourne (UTC+10:00)',
        value: 'Australia/Melbourne',
    },
    {
        label: 'Port Moresby (UTC+10:00)',
        value: 'Pacific/Port_Moresby',
    },
    {
        label: 'Sydney (UTC+10:00)',
        value: 'Australia/Sydney',
    },
    {
        label: 'Yakutsk (UTC+10:00)',
        value: 'Asia/Yakutsk',
    },
    {
        label: 'Vladivostok (UTC+11:00)',
        value: 'Asia/Vladivostok',
    },
    {
        label: 'Auckland (UTC+12:00)',
        value: 'Pacific/Auckland',
    },
    {
        label: 'Fiji (UTC+12:00)',
        value: 'Pacific/Fiji',
    },
    {
        label: 'International Date Line West (UTC+12:00)',
        value: 'Pacific/Kwajalein',
    },
    {
        label: 'Kamchatka (UTC+12:00)',
        value: 'Asia/Kamchatka',
    },
    {
        label: 'Magadan (UTC+12:00)',
        value: 'Asia/Magadan',
    },
    {
        label: 'Marshall Is. (UTC+12:00)',
        value: 'Pacific/Fiji',
    },
    {
        label: 'New Caledonia (UTC+12:00)',
        value: 'Asia/Magadan',
    },
    {
        label: 'Solomon Is. (UTC+12:00)',
        value: 'Asia/Magadan',
    },
    {
        label: 'Wellington (UTC+12:00)',
        value: 'Pacific/Auckland',
    },
    {
        label: "Nuku'alofa (UTC+13:00)",
        value: 'Pacific/Tongatapu',
    },
];

export const timezoneOption = [
    {
        label: 'Select Timezone',
        value: '',
    },
    ...timezoneList.map((tz) => ({
        label: tz.label,
        value: tz.value,
    })),
];

export const themeOption = Object.values(UserThemeEnum).map((theme) => ({
    label: theme,
    value: theme,
}));

export const roleOption = Object.values(UserRoleEnum).map((role) => ({
    label: capitalize(role),
    value: role,
}));

export const statusOption = Object.values(UserStatusEnum).map((status) => ({
    label: capitalize(status),
    value: status,
}));

export const resolutionOption = [
    { width: 2992, height: 2000 },
    { width: 3456, height: 2304 },
    { width: 3984, height: 2656 },
    { width: 4496, height: 3000 },
    { width: 4512, height: 3000 },
    { width: 5184, height: 3456 },
    { width: 6000, height: 4000 },
];

export const countryOptions = [
    { label: 'Select Country', value: '' },
    { label: 'Afghanistan', value: 'Afghanistan' },
    { label: 'Albania', value: 'Albania' },
    { label: 'Algeria', value: 'Algeria' },
    { label: 'Andorra', value: 'Andorra' },
    { label: 'Angola', value: 'Angola' },
    { label: 'Argentina', value: 'Argentina' },
    { label: 'Armenia', value: 'Armenia' },
    { label: 'Australia', value: 'Australia' },
    { label: 'Austria', value: 'Austria' },
    { label: 'Azerbaijan', value: 'Azerbaijan' },
    { label: 'Bahrain', value: 'Bahrain' },
    { label: 'Bangladesh', value: 'Bangladesh' },
    { label: 'Belarus', value: 'Belarus' },
    { label: 'Belgium', value: 'Belgium' },
    { label: 'Bhutan', value: 'Bhutan' },
    { label: 'Brazil', value: 'Brazil' },
    { label: 'Canada', value: 'Canada' },
    { label: 'China', value: 'China' },
    { label: 'Denmark', value: 'Denmark' },
    { label: 'Egypt', value: 'Egypt' },
    { label: 'Finland', value: 'Finland' },
    { label: 'France', value: 'France' },
    { label: 'Germany', value: 'Germany' },
    { label: 'India', value: 'India' },
    { label: 'Indonesia', value: 'Indonesia' },
    { label: 'Iran', value: 'Iran' },
    { label: 'Iraq', value: 'Iraq' },
    { label: 'Ireland', value: 'Ireland' },
    { label: 'Italy', value: 'Italy' },
    { label: 'Japan', value: 'Japan' },
    { label: 'Jordan', value: 'Jordan' },
    { label: 'Kenya', value: 'Kenya' },
    { label: 'Kuwait', value: 'Kuwait' },
    { label: 'Lebanon', value: 'Lebanon' },
    { label: 'Malaysia', value: 'Malaysia' },
    { label: 'Maldives', value: 'Maldives' },
    { label: 'Mexico', value: 'Mexico' },
    { label: 'Netherlands', value: 'Netherlands' },
    { label: 'New Zealand', value: 'New Zealand' },
    { label: 'Nigeria', value: 'Nigeria' },
    { label: 'Norway', value: 'Norway' },
    { label: 'Oman', value: 'Oman' },
    { label: 'Pakistan', value: 'Pakistan' },
    { label: 'Palestine', value: 'Palestine' },
    { label: 'Philippines', value: 'Philippines' },
    { label: 'Poland', value: 'Poland' },
    { label: 'Portugal', value: 'Portugal' },
    { label: 'Qatar', value: 'Qatar' },
    { label: 'Russia', value: 'Russia' },
    { label: 'Saudi Arabia', value: 'Saudi Arabia' },
    { label: 'Singapore', value: 'Singapore' },
    { label: 'South Africa', value: 'South Africa' },
    { label: 'South Korea', value: 'South Korea' },
    { label: 'Spain', value: 'Spain' },
    { label: 'Sri Lanka', value: 'Sri Lanka' },
    { label: 'Sweden', value: 'Sweden' },
    { label: 'Switzerland', value: 'Switzerland' },
    { label: 'Syria', value: 'Syria' },
    { label: 'Thailand', value: 'Thailand' },
    { label: 'Turkey', value: 'Turkey' },
    { label: 'Ukraine', value: 'Ukraine' },
    { label: 'United Arab Emirates', value: 'United Arab Emirates' },
    { label: 'United Kingdom', value: 'United Kingdom' },
    { label: 'United States', value: 'United States' },
    { label: 'Vietnam', value: 'Vietnam' },
    { label: 'Yemen', value: 'Yemen' },
];
